<template>
    <div class="w-upload">
        <div
            id="thelist"
            class="uploader-list"
        ></div>
        <div
            :id="id"
            class="upload_btn"
        >选择大文件</div>
        <el-button
            v-if="!autoUpload"
            size="mini"
            @click="start"
            :loading="uploadLoading"
            type="success"
        >上传到服务器</el-button>
        <ul
            class="el-upload-list el-upload-list--text"
            v-if="fileList.length"
        >
            <li
                class="el-upload-list__item is-success"
                v-for="(item,index) in fileList"
                :key="index"
            >
                <a class="el-upload-list__item-name">
                    <i class="el-icon-document"></i>
                    <span> {{item.filename}}</span>
                    <span
                        v-if="item.status!=='uploaded'"
                        class="status"
                    >{{item.status}}</span>
                    <span
                        v-else
                        class="status success"
                    >上传成功</span>
                </a>
                <el-progress
                    v-if="item.status === '上传中'|| item.status=== '切片中'"
                    :percentage="item.percentage"
                    :show-text="false"
                ></el-progress>
            </li>
        </ul>
    </div>
</template>

<script>
import './js/jquery';
const WebUploader = require('./js/webupload/webuploader');
const CryptoJS = require('./js/crypto-js');

function noop() {}
export default {
    name: 'VueWebUpload',
    data() {
        return {
            uploader: '',
            fileNum: 0,
            uploadLoading: false, // 上传加载效果
            filehash:''
        };
    },
    props: {
        fileguid: {
            type: String,
            required: false,
        },

        headers: {
            type: Object,
            required: false,
            default: () => ({}),
        },
        autoUpload: {
            type: Boolean,
            default: true,
            required: false,
        },
        fileList: {
            type: Array,
            required: false,
            default: () => [],
        },
        
        accept: {
            type: String,
            required: false,
        },
        id: {
            type: String,
            default: 'picker',
            required: false,
        },

        uploadUrl: {
            type: String,
            required: false,
            default: '/resource_api/storage/fdfs/batchPeaceUpload',
        },

        onSuccess: {
            type: Function,
            required: false,
            default: noop,
        },
        onRemove: {
            type: Function,
            required: false,
            default: noop,
        },
        onComplete: {
            type: Function,
            required: false,
            default: noop,
        },
        onChange: {
            type: Function,
            required: false,
            default: noop,
        },
    },
    watch: {
        
    },
    mounted() {
        // HOOK 这个必须要再uploader实例化前面
        WebUploader.Uploader.register(
            {
                'before-send-file': 'beforeSendFile',
                'before-send': 'beforeSend',
            },
            {
                beforeSendFile: function (file) {
                    // Deferred对象在钩子回掉函数中经常要用到，用来处理需要等待的异步操作。
                    var deferred = WebUploader.Deferred();
                    this.GetFileZyNoCA(file.source.source,deferred);
                    file.guid = WebUploader.Base.guid();
                    // 根据文件内容来查询MD5
                    
                        
                    return deferred.promise();
                }.bind(this),
                beforeSend: function (block) {
                    var deferred = WebUploader.Deferred();
                    var file = block.file;
                    var missChunks = file.missChunks;
                    var blockChunk = block.chunk;
                  
                    if (
                        missChunks !== null &&
                        missChunks !== undefined &&
                        missChunks !== ''
                    ) {
                        var flag = true;
                        for (var i = 0; i < missChunks.length; i++) {
                            if (blockChunk == missChunks[i]) {
                                flag = false;
                                break;
                            }
                        }
                        if (flag) {
                            deferred.reject();
                        } else {
                            deferred.resolve();
                        }
                    } else {
                        deferred.resolve();
                    }
                    return deferred.promise();
                }.bind(this),
            }
        );
        this.uploader = WebUploader.create({
            //允许重复上传
            duplicate :true,
            pick: {
                id: '#' + this.id,
                label: '点击选择文件',
            },
            formData: {
                md5: '',
                chunkSize: 5 * 1024 * 1024,
            },
            //dnd: '#dndArea',
            //paste: '#uploader',
            swf: './js/webupload/Uploader.swf',
            chunked: true,
            chunkSize: 5 * 1024 * 1024, // 字节 1M分块
            threads: 1,
            server: this.uploadUrl,
            auto: this.autoUpload,
            // 是否开启多选
            multiple: true,
            // 禁掉全局的拖拽功能。这样不会出现图片拖进页面的时候，把图片打开。
            disableGlobalDnd: true,
            accept: this.getAccept(this.accept), // 允许的文件格式
            fileNumLimit: 1024,
            fileSizeLimit: 1024 * 1024 * 1024 * 1024,
            fileSingleSizeLimit: 1024 * 1024 * 1024 * 1024,
        });
        this.w_init();
    },
    methods: {
        w_init() {

            // 当有文件被添加进队列的时候
            this.uploader.on(
                'fileQueued',
                function (file) {
                    this.$emit('loading','1');
                    if(this.fileList.length == 0){
                        this.fileList.push({
                            id: file.id,
                            filename: file.name,
                            size: file.size,
                            percentage: 0,
                            status: '',
                            raw: file,
                        });
                    }else if(this.fileList.length > 0){
                        this.$set(this.fileList, 0, {
                            id: file.id,
                            filename: file.name,
                            size: file.size,
                            percentage: 0,
                            status: '',
                            raw: file,
                        })
                    }
                    
                }.bind(this)
            );
            var that = this;
            //当某个文件的分块在发送前触发，主要用来询问是否要添加附带参数，大文件在开起分片上传的前提下此事件可能会触发多次。
            this.uploader.onUploadBeforeSend = function (obj, data, headers) {
                $.extend(headers, this.headers);
                var file = obj.file;
                data.ext = file.ext;
                data.md5 = file.md5 || '';
                data.guid = file.guid || '';
                data.size = file.size;
                data.fileguid = that.fileguid;
                data.issave = '0';
                // data.type = 'tendering';//post地址中设置
                data.typecode = 'tender';
                data.savepath = '';
                data.single = '';
                data.zbfilesha1 = that.filehash
            };
            // 上传中
            this.uploader.on(
                'uploadProgress',
                function (file, percentage, response) {
                    this.fileList.forEach((item) => {
                        if (file.id === item.id) {
                            item.percentage = percentage.toFixed(2) * 100;
                            item.status = '上传中';
                        }
                    });
                }.bind(this)
            );
            // 上传返回结果
            this.uploader.on(
                'uploadSuccess',
                function (file, response) {
                    if(response.code=='v'){
                        this.fileList.forEach((item) => {
                            if (file.id === item.id) {
                                item.percentage = 100;
                                item.status = '上传成功';
                                if (response) {
                                    item.response = response;
                                }
                            }
                        });
                        if (response) {
                            this.onSuccess(response, file, this.fileList);
                        }
                    }else if(response.code=='error'){
                        this.fileList.forEach((item) => {
                            if (file.id === item.id) {
                                item.percentage = 100;
                                item.status = '上传失败';
                            }
                        });
                        ShowMsg(response.msg, 'error');
                    }
                    this.uploadLoading = false;
                    this.$emit('loading','0');
                    
                }.bind(this)
            );
            this.uploader.on(
                'uploadError',
                function (file) {
                    this.fileList.forEach((item) => {
                        if (file.id === item.id) {
                            item.percentage = 100;
                            item.status = '上传失败';
                        }
                    });
                    ShowMsg('上传失败....', 'error');
                }.bind(this)
            );
            //文件校验格式和大小
            this.uploader.on(
                'error',
                function (type) {
                    if (type == 'Q_EXCEED_SIZE_LIMIT') {
                        ShowMsg('文件超过指定大小', 'error');
                    }
                    if (type == 'Q_TYPE_DENIED') {
                        ShowMsg('文件格式错误，请选择文件', 'error');
                    }
                    if (type == 'F_EXCEED_SIZE') {
                        ShowMsg(
                            '文件超过' + this.sizeLimit / 1024 / 1024 / 1024 + 'M',
                            'error'
                        );
                    }
                }.bind(this)
            );

            this.uploader.on(
                'uploadComplete',
                function (file) {
                    // 文件上传完成
                    this.onComplete(file, this.fileList);
                }.bind(this)
            );
        },
        // 上传开始方法
        start() {
            const fileList = this.uploader.getFiles();
            if (fileList.length > 0) {
                fileList.forEach((item) => {
                    this.uploader.upload(item.id);
                });
            } else {
                ShowMsg('请选择上传文件', 'error');
            }
        },
        
        // 上传允许类型
        getAccept(accept) {
            switch (accept) {
                case 'hzb':
                    return {
                        title: 'hzbs',
                        exteensions: accept,
                        mimeTypes: '.'+accept,
                    };
                    break;
                default:
                    return {
                        title: 'file',
                        exteensions: accept,
                        mimeTypes: '.'+accept,
                    };
            }
        },
        // 下载文件
        downTbwj(rowguid) {
            window.open(`${this.getGetters('fileUrl')}/download/tender/hzb.do?rowguid=`+rowguid+``)
                
        },
        GetFileZyNoCA(file, task) {
            var that = this
            var contractFile = file; // document.getElementById("fuFj").value;
            var reader = new FileReader();
            var blobSlice =
                File.prototype.mozSlice ||
                File.prototype.webkitSlice ||
                File.prototype.slice;
            // 指定文件分块大小(2M)
            var zyzychunksize = 5 * 1024 * 1024;
            // 计算文件分块总数
            var zychunks = Math.ceil(contractFile.size / zyzychunksize);
            // 指定当前块指针
            var currentChunk = 0;

            var hasher = CryptoJS.algo.SHA1.create();
            // FileReader分片式读取文件
            // 计算开始读取的位置
            var start = currentChunk * zyzychunksize;
            // 计算结束读取的位置
            var end =
                start + zyzychunksize >= contractFile.size
                    ? contractFile.size
                    : start + zyzychunksize;
            reader.readAsArrayBuffer(blobSlice.call(contractFile, start, end));
            reader.onload = function (evt) {
                var fileStr = evt.target.result;
                var tmpWordArray = that.arrayBufferToWordArray(fileStr);
                hasher.update(tmpWordArray);
                currentChunk += 1;
                fileStr = null;
                tmpWordArray = null;
                // 判断文件是否都已经读取完
                if (currentChunk < zychunks) {
                    // 计算开始读取的位置
                    var start = currentChunk * zyzychunksize;
                    // 计算结束读取的位置
                    var end =
                        start + zyzychunksize >= contractFile.size
                            ? contractFile.size
                            : start + zyzychunksize;
                    reader.readAsArrayBuffer(
                        blobSlice.call(contractFile, start, end)
                    );
                } else {
                    contractFile = null;
                    var hash = hasher.finalize().toString(CryptoJS.enc.Base64);
                    that.filehash = hash;
                    task.resolve();
                    /*   var $scope = angular.element(document.getElementById("myForm")).scope();
            $scope.fSavePost();  */
                    hasher = null;
                    blobSlice = null;
                    reader = null;
                    hash = null;
                }
            };
        },
        arrayBufferToWordArray(ab) {
            var i8a = new Uint8Array(ab);
            return CryptoJS.lib.WordArray.create(i8a, i8a.length);
        }
    },
};
</script>

<style>
.webuploader-container {
    position: relative;
}

.webuploader-element-invisible {
    position: absolute !important;
    clip: rect(1px 1px 1px 1px);
    /* IE6, IE7 */
    clip: rect(1px, 1px, 1px, 1px);
}

.webuploader-pick {
    position: relative;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    transition: 0.1s;
    font-weight: 500;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
    color: #fff;
    background-color: #409eff;
    border-color: #409eff;
    padding: 7px 15px;
    font-size: 12px;
    border-radius: 3px;
}

.webuploader-pick-hover {
    background: #66b1ff;
    border-color: #66b1ff;
    color: #fff;
}

.webuploader-pick-disable {
    opacity: 0.6;
    pointer-events: none;
}

.el-upload__tip {
    font-size: 12px;
    color: #606266;
    margin-top: 7px;
}

.el-upload-list {
    margin: 0;
    padding: 0;
    list-style: none;
}

.el-upload-list__item {
    -webkit-transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
    transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
    font-size: 14px;
    color: #606266;
    line-height: 1.8;
    margin-top: 5px;
    position: relative;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 4px;
    width: 100%;
}

.el-upload-list__item-name {
    color: #606266;
    display: block;
    margin-right: 40px;
    overflow: hidden;
    padding-left: 4px;
    text-overflow: ellipsis;
    -webkit-transition: color 0.3s;
    transition: color 0.3s;
    white-space: nowrap;
}

.upload_btn {
    display: inline-block;
    margin-right: 20px;
}

.status {
    display: inline-block;
    padding-left: 20px;
    color: #e6a23c;
}

.success {
    color: #67c23a;
}

.w-upload {
}
</style>
